import { observable, action } from 'mobx';
import ApiClient from './ApiClient';

export default class LanguageStore extends ApiClient {
  @observable
  language = process.env.REACT_APP_DEFAULT_LANGUAGE || 'fi';

  @observable
  languages = (process.env.REACT_APP_LANGUAGES || 'fi').split(',')

  @action
  setLanguage(language) {
    this.language = language;
  }
}



// WEBPACK FOOTER //
// ./src/store/LanguageStore.js